import React from 'react'
import { Skeleton, useViewport } from '@chilecompra/react-kit'

/**
 * The List Participant loading component.
 */
const ListParticipantsLoading = () => {
  const {
    size: { isUpToMedium }
  } = useViewport()

  const heightValidation = position => {
    if (position === 1) {
      return isUpToMedium ? '306px' : '585px'
    } else {
      return isUpToMedium ? '373px' : '711px'
    }
  }

  return (
    <>
      <Skeleton height={heightValidation(1)} margin="2.5rem 0 2rem" variant="rect" width="100%" />
      <Skeleton height={heightValidation(2)} margin="0 0 2rem" variant="rect" width={isUpToMedium ? '48%' : '100%'} />
      <Skeleton
        height={heightValidation(2)}
        margin={!isUpToMedium ? '0 0 2rem' : '0 0 2rem 2rem'}
        variant="rect"
        width={isUpToMedium ? '48%' : '100%'}
      />
    </>
  )
}

export default ListParticipantsLoading
